<template>
<!--  -->
  <div class='policy-release'>
    <div style="margin-bottom: 20px">
      <CarouselPage></CarouselPage>
    </div>
    <div style='padding: 0 8%'>
      <div class='search-action'>
        <div class="title"><Icon type="md-search" style="font-size: 20px" />筛选条件</div>
        <div class="content">
          <div class='form'>
            <Form :model="searchParam" inline :label-width="150" label-position="right">
                <Row :gutter="16">
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                      <FormItem label="黑名单对象类别：" style="width: 100%">
                        <div class='cover-b-l-t-l'>
                          <p
                            v-for='item in blackListTypeList'
                            :key='"b-l-t-l-" + item.dicCode'
                            @click='searchParam.blackCategory = item.dicCode'
                            :class='{"b-l-t-l": true, action: searchParam.blackCategory === item.dicCode}'
                            >{{item.dicName}}</p>
                        </div>
                      </FormItem>
                  </Col>
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                      <FormItem label="认定日期：" style="width: 100%">
                        <DatePicker type="daterange" :value='searchParam.queryTime' split-panels placeholder="请选择认定日期范围" clearable @on-change='handleDateChange' style='width: 100%'></DatePicker>
                      </FormItem>
                  </Col>
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                      <FormItem label="黑名单记录主体：" style="width: 100%">
                          <Input v-model="searchParam.name" clearable placeholder="请输入黑名单记录主体" />
                      </FormItem>
                  </Col>
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                      <FormItem label="认定部门：" style="width: 100%">
                          <Input v-model="searchParam.department" clearable placeholder="请输入认定部门" />
                      </FormItem>
                  </Col>
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                      <FormItem label="黑名单类型：" style="width: 100%">
                        <Select v-model="searchParam.blackType" clearable>
                            <Option v-for="item in _dict.black_type" :value="item.dicCode" :key="item.dicCode" style="max-width: 600px; overflow: hidden; text-overflow: ellipsis;" :title='item.dicName'>{{ item.dicName }}</Option>
                        </Select>
                      </FormItem>
                  </Col>
                  <Col :xs="12" :sm="8" :md="12" :lg="12">
                    <div class='action-btn'>
                      <Button type="primary" @click='handleSearch' style="width: 100px; margin-right: 20px;">开始查询</Button>
                        <Button style="width: 100px;" @click="handleInitParam">重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置</Button>
                    </div>
                  </Col>
                </Row>
            </Form>
          </div>
          <!-- <div class='action'>

          </div> -->
        </div>
      </div>
      <div class="cover-table">
        <Table :columns="columns" border :data="tableData" highlight-row style="margin-bottom: 20px">
            <template slot-scope="{ row }" slot="blacklistNum">
                <div class="black-list-num">
                  <span class='hmd'>黑名单</span>
                  <span>{{row.blacklistNum}}</span>
                </div>
            </template>
            <template slot-scope="{ row }" slot="name">
                <span class='pointer' @click="handleDeal(row)">{{row.name}}</span>
            </template>
            <template slot-scope="{ row }" slot="blackType">
                <div style='width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;' :title='row.blackType'>{{row.blackType}}</div>
            </template>
          </Table>
          <div style="display: flex; flex-direction: row; justify-content: center;">
              <Page class-name='pageBorder' :total="searchParam.totalCount" :page-size="searchParam.pageSize" :current="searchParam.currentPage" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
              </Page>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tableMixin from '@/components/tableMixin';
import { getBlackListList } from '@/api/homePage.js'
import CarouselPage from './carouselPage.vue'

export default {
  name: '',
  props: {

  },
  data () {
    return {
      carousel: 0,
      imgList: [],
      blackListTypeList: [
        {
          dicName: '全部',
          dicCode: 0
        }, {
          dicName: '工程建设企业',
          dicCode: 1
        }, {
          dicName: '从业人员',
          dicCode: 2
        }
      ],
      searchParam: {
        blackCategory: 0,
        queryTime: ['', ''],
        queryStartTime: '',
        queryEndTime: '',
        name: '',
        department: '',
        blackType: '',
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      columns: [
        {
            title: '黑名单记录编号',
            key: 'blacklistNum',
            align: 'center',
            width: 180,
            slot: 'blacklistNum',
            className: 'cell-hmd'
        },
        {
            title: '黑名单记录主体',
            key: 'name',
            align: 'center',
            minWidth: 200,
            slot: 'name',
        },
        {
            title: '黑名单类型',
            key: 'blackType',
            minWidth: 200,
            align: 'center',
            slot: 'blackType',
            className: 'color-black08'
        },
        {
            title: '黑名单认定依据',
            key: 'cognizanceBasis',
            minWidth: 200,
            align: 'center',
            className: 'color-black08'
        },
        {
            title: '认定部门',
            key: 'cognizanceDepartment',
            align: 'center',
            width: 120,
            className: 'color-black08'
        },
        {
            title: '列入黑名单日期',
            key: 'blacklistStartDate',
            align: 'center',
            width: 140,
            className: 'color-black08'
        },
        {
            title: '移出黑名单日期',
            key: 'blacklistEndDate',
            align: 'center',
            width: 140,
            className: 'color-black08'
        },
      ],
      tableData: []
    }
  },
  mixins: [tableMixin],
  components: {
    CarouselPage
  },
  computed: {
    ...mapGetters(['_dict'])
  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    handleInitParam() {
      this.searchParam = {
        blackCategory: 0,
        queryTime: ['', ''],
        queryStartTime: '',
        queryEndTime: '',
        name: '',
        department: '',
        blackType: '',
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      }
      this.handleSearch()
    },
    handleSearch() {
      this.getTableData()
    },
    // 获取表格数据
    getTableData() {
      const { blackCategory, queryStartTime, queryEndTime, name, department, currentPage, pageSize, blackType } = this.searchParam
      // console.log(this.searchParam)
      getBlackListList({
        blackCategory, queryStartTime, queryEndTime, name, department, currentPage, pageSize, blackType
      }).then((res) => {
        // console.log(res)
        if (res.status === 200) {
          const { list, total } = res.data
          list.map((item) => {
            item.blackType = this._dict.black_type.find((it) => it.dicCode == item.blackType) ? this._dict.black_type.find((it) => it.dicCode == item.blackType).dicName : item.blackType
          })
          this.tableData = list
          this.searchParam.totalCount = total
        }
      }).catch(() => {
        this.$Message.error('获取列表信息失败')
      })
    },
    /*处理操作*/
    handleDeal({ blackCategory = 1, code = '' }){
        const query = blackCategory == 1 ? {
          corpCode: code
        } : {
          idCard18: code
        }
        this.$router.push({
            name: blackCategory == 1 ? 'blackListCorpDetail' : 'blackListPersonDetail',
            query
        });
    },
    handleDateChange(val) {
      this.searchParam.queryStartTime = val[0] || ''
      this.searchParam.queryEndTime = val[1] || ''
    }
  }
}
</script>

<style lang="less" scoped>
  .policy-release {
    background: #EEF3F6;
    height: 100%;
    padding: 0 0px 20px;
    .cover-table {
      background: #fff;
      border-radius: 4px;
      padding: 15px;
      .black-list-num {
        position: relative;
        .hmd {
          position: absolute;
          background: red;
          color: #fff;
          transform: scale(0.7) rotate(-45deg);
          font-size: 12px;
          left: -21px;
          top: 2px;
        }
      }
    }
  }

</style>
<style lang="less">
  .cover-table {
    .cell-hmd {
      padding: 0px;
      color: #808080;
    }
    .color-black08 {
      color: #808080;
    }
  }
  .pageBorder {
      .ivu-page-item {
          border-radius: 100%;
      }
      .ivu-page-prev {
          border-radius: 100%;
      }
      .ivu-page-next {
          border-radius: 100%;
      }
      .ivu-page-next {
          border-radius: 30px;
      }
      .ivu-page-options-elevator input {
          border-radius: 30px;
      }
  }
</style>
<style lang="less" scoped>
  .search-action {
    background: #fff;
    margin: 15px 0;
    &>.title {
      // height: 30px;
      font-size: 18px;
      padding: 8px 12px;
      line-height: 22px;
      border-bottom: 2px solid #EFEFEF;
    }
    &>.content {
      padding: 15px 0 0 ;
      display: flex;
      flex-direction: row;
      &>.form {
        flex: 1;
        padding: 0 20px;
        .cover-b-l-t-l {
          height: 34px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .b-l-t-l {
            width: 33%;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #0180DD;
            border-radius: 3px;
            cursor: pointer;
          }
          .b-l-t-l.action {
            color: #fff;
            background: #0180DD;
          }
        }
        .action-btn {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
        }
      }
      // &>.action {
      //   width: 170px;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: center;
      //   align-items: center;
      // }
    }
  }

</style>
